var render = function render(){var _vm=this,_c=_vm._self._c;return _c('menu-layout',{attrs:{"loading":_vm.loading}},[_c('row',[_c('col2',[_c('page-menu',{attrs:{"name":"AI models","title":"Smartify your Box"}})],1),_c('col10',{staticStyle:{"max-width":"800px"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }